module.exports = __webpack_public_path__ + "static/media/patentar.291327d3.png";